module.exports = __webpack_public_path__ + "fonts/CircularStd-Black.2945a272.woff";